import { render, staticRenderFns } from "./FormElementExplain.vue?vue&type=template&id=2d415a44&scoped=true&"
import script from "./FormElementExplain.vue?vue&type=script&lang=js&"
export * from "./FormElementExplain.vue?vue&type=script&lang=js&"
import style0 from "./FormElementExplain.vue?vue&type=style&index=0&id=2d415a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d415a44",
  null
  
)

export default component.exports